import request from '../utils/request';

// 添加物流公司
export function addLogisticsCompany(data) {
  return request({
    url: '/logistics-company',
    method: 'post',
    data: {
      name: data.name,
      code: data.code,
      status: data.status || 1
    }
  });
}

// 更新物流公司
export function updateLogisticsCompany(data) {
  return request({
    url: '/logistics-company',
    method: 'put',
    data: {
      id: data.id,
      name: data.name,
      code: data.code,
      status: data.status
    }
  });
}

// 删除物流公司
export function deleteLogisticsCompany(logisticsCompanyId) {
  return request({
    url: `/logistics-company/${logisticsCompanyId}`,
    method: 'delete'
  });
}

// 分页查询物流公司
export function pageLogisticsCompanies(params) {
  return request({
    url: '/logistics-company/page',
    method: 'get',
    params: {
      page: params.page || 1,
      pageSize: params.pageSize || 10,
      name: params.name,
      code: params.code,
      status: params.status,
      ...params
    }
  });
}

// 获取物流公司详情
export function getLogisticsCompanyDetail(logisticsCompanyId) {
  return request({
    url: `/logistics-company/${logisticsCompanyId}`,
    method: 'get'
  });
}
